// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Rational_Extra from "../Data.Rational.Extra/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
var editAsStringString = /* #__PURE__ */ (function () {
    return {
        toString: Control_Category.identity(Control_Category.categoryFn),
        parse: Data_Either.Right.create
    };
})();
var editAsStringRational = {
    toString: /* #__PURE__ */ Data_Rational_Extra.toString(Data_Rational_Extra.asRationalSerialized),
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_rational))(Data_Rational_Extra.fromString(Data_Rational_Extra.asRationalSerialized)(s));
    }
};
var editAsStringNumber = {
    toString: /* #__PURE__ */ Data_Show.show(Data_Show.showNumber),
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_number))(Data_Number.fromString(s));
    }
};
var editAsStringMoney = {
    toString: Data_Money_Rounded.toString,
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_money))(Data_Money_Rounded.fromString(s));
    }
};
var editAsStringInt = {
    toString: /* #__PURE__ */ Data_Show.show(Data_Show.showInt),
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_int))(Data_Int.fromString(s));
    }
};
var toString = function (dict) {
    return dict.toString;
};
var parse = function (dict) {
    return dict.parse;
};
var editAsStringMaybe = function (dictEditAsString) {
    return {
        toString: Data_Maybe.maybe("")(toString(dictEditAsString)),
        parse: function (v) {
            if (v === "") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(Data_Maybe.Nothing.value);
            };
            return Data_Functor.map(Data_Either.functorEither)(Data_Maybe.Just.create)(parse(dictEditAsString)(v));
        }
    };
};
export {
    parse,
    toString,
    editAsStringString,
    editAsStringInt,
    editAsStringNumber,
    editAsStringRational,
    editAsStringMoney,
    editAsStringMaybe
};
//# sourceMappingURL=index.js.map
